import {URL_BASE_API } from '../configs/urlConfigs';
import {LOGIN_CLIENT_GROUP} from '../configs/staticConfigs';

import service from './api';

export const documentList = (request) => {     
    let ENDPOINT = '';
    if(request.data!==undefined){ 
        let crew     = request.data.crew;  
        let client   = request.data.client;        
        if(crew){
            ENDPOINT = URL_BASE_API+'affiliate/document-details/?crew_profile='+crew;
        } 
        if(client){
            ENDPOINT = URL_BASE_API+'affiliate/document-details/?client_profile='+client;
        }   
    }
    return service.get(ENDPOINT);  
}; 

export const skillDocumentList = (request) => {     
    let ENDPOINT = '';
    if(request.data!==undefined){ 
        let crew     = request.data.crew;  
        let client   = request.data.client;     
        let document = request.data.document ? request.data.document : 0;
        let client_id= request.data.client_id ? request.data.client_id : 0;   
        if(crew){
            ENDPOINT = URL_BASE_API+'affiliate/list-crew-doc-skill/?crew_profile='+crew;
        } 
        if(client){
            let userType = LOGIN_CLIENT_GROUP;
            ENDPOINT = URL_BASE_API+'affiliate/docs_v2/?user='+userType;
            // VARIABLES document AND client_id ARE PASSED ON THE REQUEST OF SERVER TEAM ON 24Nov2020 
            if(document > 0) ENDPOINT += '&document='+document;
            if(client_id > 0) ENDPOINT += '&client_id='+client_id;
        }   
    }
    return service.get(ENDPOINT);  
}; 

export const documentAdd = (request) => {     
    const ENDPOINT = URL_BASE_API+'affiliate/document-details/';
  
    return service.post(ENDPOINT,request.data);   
};  

export const documentEdit = (request) => {
    let docId = request.data;
    const ENDPOINT = URL_BASE_API+'affiliate/document-details/'+docId;
  
    return service.get(ENDPOINT);      
}; 

export const documentUpdate = (request) => {
    let docId = request.data.docId;
    const ENDPOINT = URL_BASE_API+'affiliate/document-details/'+docId;
    delete request.data.docId;
    return service.put(ENDPOINT,request.data);  
    
}; 

export const documentDelete = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/document-details/'+request.data;  
    return service.delete(ENDPOINT,request.data);
};


export const documentFileSave = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/documents/';  
    return service.post(ENDPOINT,request.data);
};

export const documentFileDelete = (request) => {
    let fileId = request.data.fileId;
    let docId = request.data.docId;

    const ENDPOINT = URL_BASE_API+'affiliate/documents/'+fileId+'?document_details_id='+docId; 
    return service.delete(ENDPOINT);
};

export const documentStatusUpdate = (request) => {
    let docId = request.data.docId;
    const ENDPOINT = URL_BASE_API+'affiliate/change-document-status/'+docId;  
    delete request.data.docId;
    return service.put(ENDPOINT,request.data);  
};

export const passportFileSave = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/passport/';  
    return service.post(ENDPOINT,request.data);
};

export const visaFileSave = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/visa/';  
    return service.post(ENDPOINT,request.data);
};